<template>
  <span />
</template>

<script>
export default {
  name: 'login-or-redirect',
  mounted () {
    if (this.$store.state.token) {
      this.$router.push({ name: 'my-services' })
    } else {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
</style>
